import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99e8e9c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=99e8e9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e8e9c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e8e9c4')) {
      api.createRecord('99e8e9c4', component.options)
    } else {
      api.reload('99e8e9c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=99e8e9c4&scoped=true&", function () {
      api.rerender('99e8e9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/onboarding/views/index.vue"
export default component.exports